export default "__VITE_ASSET__CdKVsLuy__"